export * from '#universal/how-kody-works-transcript.ts'
